import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "7 6 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M42 57H22A15 15 0 0 1 8 42V22A15 15 0 0 1 22 7h13a15 15 0 0 1 15 15v.5a2.5 2.5 0 0 0 2.5 2.5 4.5 4.5 0 0 1 4.5 4.5V42a15 15 0 0 1-15 15ZM24.5 20a2.5 2.5 0 0 0 0 5h11a2.5 2.5 0 0 0 0-5Zm0 18a2.5 2.5 0 0 0 0 5h17a2.5 2.5 0 0 0 0-5Z"
    }, null, -1)
  ])))
}
export default { render: render }